const Kategoriya3212 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
    <h3 className="text-center text-primary">
        3-sinf 2-chorak<br />
        Mavzu: Gap bo'laklari<br />
        "Oson" bo'limidagi topshiriqlar va ularni o'tkazish metodikasi
    </h3>
    <b>1-mashq. Nuqtalar o'rniga mazmunga mos so'zni qo'ying.</b><br />
    <i>Ta'limiy maqsad:</i> O'quvchilarning gap bo'laklari haqidagi ko'nikmalarini rivojlantirish.<br />
    <i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa<br />
    Nafisa …, …, … qalamlarni yaxshi ko'radi.<br />
    Botir … yurdi, lekin tezda ortiga … .
    <p><b>2-mashq. Juftlikda ishlang. Nuqtalar o'rniga qavs ichida berilgan so'zlardan mosini qo'yib ko'chiring.</b></p>
    <p><i>Ta'limiy maqsad:</i> O'quvchilarning gap bo'laklari haqidagi ko'nikmalarini rivojlantirish.</p>
    <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
    <p>Bo'rilar … (uvillaydi, g'ingshiydi, akillaydi), itlar esa … (g'ingshiydi, vovillaydi, qichqiradi).</p>
    <p>… (akam, ukam, Anvar) sergap bola, u doimo kim bilandir … (olishib, suhbatlashib, gaplashib, janjallashib) o'tiradi.</p>
    <p><b>3-mashq. FDM usulidan foydalanib, berilgan fikrni izohlang.</b></p>
    <p><i>Ta'limiy maqsad:</i> O'quvchilarning bog'lanishli nutq haqidagi ko'nikmalarini rivojlantirish.</p>
    <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
    <p><b>Ma'naviy barkamollik – yurtimiz kelajagi</b></p>
    <p>Fikr: ___________________________________________________________</p>
    <p>Dalil: _________________________________________________________</p>
    <p>Misol: ________________________________________________________</p>
        </div>
    )
}
export default Kategoriya3212;